import t from "./_toPath.js";
import r from "./_deepGet.js";
import e from "./isUndefined.js";
function o(o, f, i) {
  var m = r(o, t(f));
  return e(m) ? i : m;
}
export { o as default };